import { isValidNumber } from '@edicom/common/number/isValidNumber';
import { isLocaleFormat } from '@edicom/common/number/isLocaleFormat';
import { formatFactory } from '@edicom/common/number/formatFactory';
import { isNumber } from '@edicom/common/number/isNumber';
import { divide } from '@edicom/common/number/divide';

export default {
  isValidNumber,
  isLocaleFormat,
  formatFactory,
  isNumber,
  divide, // @odeniel 20201117 DEPRECATED. usar el divide del servicio "math" ecMathService.divide
};
